<template>
  <span>
    <span v-if="value === undefined || value === null">-</span>
    <span v-if="value === false">
      <v-tooltip bottom max-width="400">
        <template v-slot:activator="{ on, attrs }">
          <v-icon small v-bind="attrs" v-on="on" color="grey">mdi-refresh</v-icon>
        </template>
        <span>
          {{ $t('error') }}
        </span>
      </v-tooltip>
    </span>
    <span v-else-if="value === 1">
      <v-chip small color="success" dark @click="$emit('click', $t('states.indexed'))">{{ $t('states.indexed') }}</v-chip>
    </span>
    <span v-else>
      <v-chip small color="error" dark @click="$emit('click', $t('states.no-indexed'))">{{ $t('states.no-indexed') }}</v-chip>
    </span>
  </span>
</template>

<script>
export default {
  name: 'UrlFound',
  props: ['value'],
}
</script>

<i18n>
{
	"en": {
		"error": "The analysis has encountered an error and will be restarted in a few minutes."
	},
	"es": {
		"error": "El análisis ha detectado un error y se reiniciará en unos minutos."
	},
	"fr": {
		"error": "L'analyse a rencontré une erreur et sera relancée dans quelques minutes."
	},
	"it": {
		"error": "L'analisi ha riscontrato un errore e verrà riavviata tra qualche minuto."
	},
	"pt": {
		"error": "A análise encontrou um erro e será reiniciada em alguns minutos."
	},
	"pl": {
		"error": "Analiza napotkała błąd i zostanie wznowiona za kilka minut."
	}
}
</i18n>
